import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalPort() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Port: Smart Connectivity for Modern Port Operations
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance port efficiency, safety, and automation with advanced
          4G/5G-enabled solutions.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">FlexNet Port</span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Streamline port operations with FlexNet Port. Our robust 4G/5G
              connectivity ensures real-time monitoring, automated logistics,
              enhanced worker safety, and optimized resource management for
              modern port environments.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://e.huawei.com/-/mediae/EBG/Images/case-study/Content-Graphics/7-4-The-Worlds-Largest-Automated-Container-Port-Operates.jpg?la=en"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">Choose FlexNet Port?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Port </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  High-speed, low-latency 4G/5G connectivity
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Edge computing for real-time decision-making
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure data transmission with encryption protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with port management systems
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Scalable architecture for diverse port environments
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Transform Your Port Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Real-Time Asset Tracking for Containers, Cranes, and Vehicles",
    detail:
      "Monitor and manage port assets efficiently with IoT-enabled tracking.",
    icon: "pi pi-map",
  },
  {
    title:
      "Automation Support for AGVs, RTGs (Rubber-Tired Gantry Cranes), and Port Logistics",
    detail:
      "Enhance port operations with automated equipment and low-latency control.",
    icon: "pi pi-cog",
  },
  {
    title: "Enhanced Safety with AI-Driven Surveillance and Worker Monitoring",
    detail:
      "Ensure workforce and cargo safety through intelligent monitoring solutions.",
    icon: "pi pi-video",
  },
  {
    title: "Predictive Maintenance to Minimize Equipment Downtime",
    detail: "Reduce unexpected failures and optimize maintenance schedules.",
    icon: "pi pi-chart-line",
  },
  {
    title: "Improved Operational Efficiency Through Data-Driven Insights",
    detail: "Leverage analytics to streamline port operations and logistics.",
    icon: "pi pi-chart-bar",
  },
  {
    title:
      "Secure, High-Speed 4G/5G Connectivity Even in Challenging Environments",
    detail:
      "Ensure reliable communication and data exchange for port operations.",
    icon: "pi pi-wifi",
  },
];

const useCases = [
  {
    title: " 1: Real-Time Container Tracking and Management",
    description:
      "Enable end-to-end tracking of containers with IoT sensors and 4G/5G connectivity, ensuring visibility from ship to shore.",
    benefits: [
      { title: "Reduce container misplacement", icon: "pi pi-box" },
      { title: "Optimize yard operations", icon: "pi pi-map" },
      { title: "Enhance supply chain transparency", icon: "pi pi-eye" },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "4G/5G Gateways", icon: "pi pi-wifi" },
      { title: "GPS Trackers", icon: "pi pi-map" },
    ],
    applications: [
      { title: "Container Yards", icon: "pi pi-globe" },
      { title: "Terminals", icon: "pi pi-building" },
      { title: "Logistics Hubs", icon: "pi pi-briefcase" },
    ],
  },
  {
    title: " 2: Automated Guided Vehicle (AGV) Operations",
    description:
      "Deploy AGVs for efficient movement of goods, powered by low-latency 4G/5G networks for real-time control.",
    benefits: [
      { title: "Improve cargo handling efficiency", icon: "pi pi-arrows-alt" },
      { title: "Reduce operational costs", icon: "pi pi-dollar" },
      {
        title: "Minimize human intervention for safer operations",
        icon: "pi pi-user-minus",
      },
    ],
    devices: [
      { title: "AGVs", icon: "pi pi-car" },
      { title: "4G/5G CPEs", icon: "pi pi-wifi" },
      { title: "Edge Computing Nodes", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Ports", icon: "pi pi-anchor" },
      { title: "Terminals", icon: "pi pi-building" },
      { title: "Warehouses", icon: "pi pi-box" },
    ],
  },
  {
    title: " 3: Crane Automation and Remote Monitoring",
    description:
      "Facilitate remote monitoring and automation of port cranes using 4G/5G networks for seamless data transmission.",
    benefits: [
      { title: "Enhance operator safety", icon: "pi pi-shield" },
      { title: "Improve precision and reduce downtime", icon: "pi pi-cog" },
      {
        title: "Enable predictive maintenance for critical equipment",
        icon: "pi pi-chart-line",
      },
    ],
    devices: [
      { title: "RTGs", icon: "pi pi-truck" },
      { title: "Cranes", icon: "pi pi-box" },
      { title: "Sensors", icon: "pi pi-cloud" },
      { title: "4G/5G Modems", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Container Terminals", icon: "pi pi-globe" },
      { title: "Bulk Handling Facilities", icon: "pi pi-briefcase" },
    ],
  },
  {
    title: " 4: Worker Safety and Real-Time Monitoring",
    description:
      "Use AI-powered surveillance and wearable devices connected via 4G/5G to monitor worker health and safety.",
    benefits: [
      { title: "Immediate emergency alerts", icon: "pi pi-bell" },
      {
        title: "Improved compliance with safety regulations",
        icon: "pi pi-check",
      },
      { title: "Enhanced operational visibility", icon: "pi pi-eye" },
    ],
    devices: [
      { title: "Wearables", icon: "pi pi-mobile" },
      { title: "AI Cameras", icon: "pi pi-camera" },
      { title: "Safety Sensors", icon: "pi pi-shield" },
    ],
    applications: [
      { title: "Port Operations", icon: "pi pi-anchor" },
      { title: "Cargo Handling Areas", icon: "pi pi-box" },
    ],
  },
  {
    title: " 5: Predictive Maintenance for Port Equipment",
    description:
      "Implement predictive analytics using real-time data from connected machinery to anticipate equipment failures.",
    benefits: [
      { title: "Minimize unplanned downtime", icon: "pi pi-clock" },
      { title: "Optimize maintenance schedules", icon: "pi pi-calendar" },
      { title: "Extend equipment lifespan", icon: "pi pi-chart-bar" },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Predictive Analytics Platforms", icon: "pi pi-brain" },
      { title: "4G/5G Connectivity", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Cranes", icon: "pi pi-box" },
      { title: "AGVs", icon: "pi pi-car" },
      { title: "Port Machinery", icon: "pi pi-cog" },
    ],
  },
];
